const countries = {
  ca: '1',
  mx: '52',
  us: '1',
}

const IS_LETTERS_ONLY = /^[+A-Za-z]+$/

function getRawNumbers(phoneNumber) {
  let number = ''

  if (phoneNumber && !IS_LETTERS_ONLY.test(phoneNumber)) {
    number = phoneNumber.match(/\d/g)
    number = number.join('')
  }

  return number
}

/**
 * @param {string} [phoneNumber]
 * @param {string} formatString
 * @returns {string}
 */
function format(phoneNumber, formatString) {
  if (!phoneNumber) return ''

  if (IS_LETTERS_ONLY.test(phoneNumber)) {
    return ''
  }

  let number = getRawNumbers(phoneNumber)
  let result = formatString

  for (let digit of number) {
    result = result.replace('X', digit)
  }

  return result
}

function normalize(phoneNumber) {
  let number = getRawNumbers(phoneNumber)

  if (phoneNumber.indexOf('+') > -1) {
    number = `+${number}`
  }

  return number
}

function getNational(phoneNumber, country) {
  if (!phoneNumber) return ''

  if (phoneNumber.indexOf('+') === -1) return getRawNumbers(phoneNumber)

  let number = getRawNumbers(phoneNumber)

  return number.replace(countries[country.toLowerCase()], '')
}

function getInternational(phoneNumber, country) {
  if (!phoneNumber) return ''

  let number = getRawNumbers(phoneNumber)

  return `+${countries[country.toLowerCase()]}${number}`
}

export const phoneNumber = { normalize, format, getNational, getInternational }

export default phoneNumber
